import React from 'react';

import MultipleChoiceExercisePreview from '@ts-core/modules/multipleChoiceExercises/components/MultipleChoiceExercisePreview';
import { MultipleChoiceExerciseWithResults } from '@ts-core/modules/multipleChoiceExercises/types';

import FillInTheBlanksExercisePreview from '@ts-core/modules/fillInTheBlanksExercises/components/FillInTheBlanksExercisePreview';
import { FillInTheBlanksExerciseWithResults } from '@ts-core/modules/fillInTheBlanksExercises/types';

import { CoreExercise } from '../../types';

interface ExercisePreviewHandlerProps {
  exercise: CoreExercise;

  hideScores?: boolean;
  hideNoAnswerOption?: boolean;
  hideQuestionBackgroundColor?: boolean;
}

const ExercisePreviewHandler = (props: ExercisePreviewHandlerProps) => {
  const { exercise, hideScores, hideNoAnswerOption, hideQuestionBackgroundColor } = props;
  if (exercise.type === 'FillInTheBlanksExercise') {
    return (
      <FillInTheBlanksExercisePreview
        exercise={exercise as FillInTheBlanksExerciseWithResults}
        hideQuestionBackgroundColor={hideQuestionBackgroundColor}
        hideScores={hideScores}
      />
    );
  }
  return (
    <MultipleChoiceExercisePreview
      exercise={exercise as MultipleChoiceExerciseWithResults}
      hideNoAnswerOption={hideNoAnswerOption}
      hideScores={hideScores}
      hideQuestionBackgroundColor={hideQuestionBackgroundColor}
    />
  );
};

export default ExercisePreviewHandler;
